import { AxiosResponse } from "axios";
import { all, call, put, takeEvery } from "redux-saga/effects";
import api from "../../api";
import Endpoint from "../../shared/endpoints";
import distributorConstants from "../constants/distributorConstants";

const getDistributors = (payload: any) =>
  api.get(Endpoint.getDistributors, {
    params: {
      ...(payload.clientId && { client: payload.clientId }),
      page: payload.page,
      ...(payload.pageSize && { page_size: payload.pageSize }),
      ...(payload.searchText && { search: payload.searchText }),
    },
  });
const createDistributor = (payload: any) =>
  api.post(Endpoint.createDistributor, payload);

const editDistributor = (id: string, payload: any) =>
  api.patch(`${Endpoint.editDistributor}/${id}/`, payload);

function* getDistributorsAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(getDistributors, action.payload);
    yield put({
      type: distributorConstants.GET_DISTRIBUTORS_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({
      type: distributorConstants.GET_DISTRIBUTORS_FAILURE,
      err: e,
    });
  }
}

function* createDistributorAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(
      createDistributor,
      action.payload,
    );
    yield put({
      type: distributorConstants.CREATE_DISTRIBUTOR_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({
      type: distributorConstants.CREATE_DISTRIBUTOR_FAILURE,
      err: e,
    });
  }
}

function* editDistributorAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(
      editDistributor,
      action.id,
      action.payload,
    );
    yield put({
      type: distributorConstants.EDIT_DISTRIBUTOR_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: distributorConstants.EDIT_DISTRIBUTOR_FAILURE, err: e });
  }
}

function* distributorSaga() {
  yield all([
    takeEvery(
      distributorConstants.GET_DISTRIBUTORS_REQUEST,
      getDistributorsAsync,
    ),
    takeEvery(
      distributorConstants.CREATE_DISTRIBUTOR_REQUEST,
      createDistributorAsync,
    ),
    takeEvery(
      distributorConstants.EDIT_DISTRIBUTOR_REQUEST,
      editDistributorAsync,
    ),
  ]);
}

export default distributorSaga;
